import type { AnyAction } from 'redux';

const defaultState = null;

const RESET = 'formData/sourceProductId/RESET';
const UPDATE = 'formData/sourceProductId/UPDATE';

export const actionResetSourceProductId = () => ({
  type: RESET,
});

export const actionUpdateSourceProductId = (value: string) => ({
  type: UPDATE,
  value,
});

export default (state: State = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
